module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('login-header', {
    attrs: {
      "systemName": _vm.systemName,
      "pageType": "login"
    }
  }), _vm._v(" "), _c(_vm.componentName, {
    tag: "component"
  }), _vm._v(" "), _c('water-marker', {
    key: _vm.waterMarkerKey,
    attrs: {
      "textStyle": _vm.waterMarkerTextStyle,
      "text": _vm.waterMarkerText || _vm.setting.defaultWaterMarker
    }
  }), _vm._v(" "), _c('login-footer', {
    attrs: {
      "copyright": _vm.copyright,
      "ICP": _vm.setting.ICP
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2c53ff78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/login/Common.vue
// module id = eUWj
// module chunks = 273